import { render, staticRenderFns } from "./SvgLoader.vue?vue&type=template&id=922b7bee&"
import script from "./SvgLoader.vue?vue&type=script&lang=js&"
export * from "./SvgLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports